export default {
  home: {
    title: 'Startseite',
    aiBannerTxt: {
      title: 'KI-Bildung verwirklichen',
      subtitle: 'KI+ Bildung digitale Befähigung, Integration innovativer Konzepte',
      description: 'Fokus auf maßgeschneiderte Laserprodukte und technische Dienstleistungen, Unterstützung von Institutionen und Unternehmen bei der Integration von "AI+ Education"'
    },
    description: 'Willkommen auf unserer Vue.js-Marketing-Website',
    banner: {
      slide1: {
        title: 'STEAM-Kits | KI-Kits | Laserschneid-Kits',
        description:
          'Wir bieten innovative STEAM-Bildungslösungen und verschiedene Kits für Familien, Pädagogen und Vertriebspartner, speziell für Kinder im Alter von 3 bis 16 Jahren.',
      },
      slide2: {
        title:
          'Professionelle Kits, speziell für die Kreativität von Kindern entwickelt',
        description:
          'Kurse, Geräte und Software integriert, einfaches Projektbasiertes Lernen',
      },
      slide3: {
        title: 'Technologische Bildung für die Zukunft',
        description:
          'Praktische Erfahrungen, interdisziplinäre Integration, Förderung von Problemlösungs- und Teamfähigkeiten',
      },
    },
    factory: {
      banner: {
        alt: 'Intelligente Fabrik Banner',
        title: 'Intelligente Fabriklösungen',
        description:
          'Aufbau von Produktionslinien｜Industrielle Sensorik｜PLC-Steuerung und Datenerfassung',
        image: 'https://picsum.photos/seed/factory-banner/1000/600',
      },
      resourcesTitle: 'Lehrmaterialien',
      resources: [
        {
          title: 'Projektbasierte Unterrichtsmaterialien',
          desc: 'Kurs-PPTs und Handouts, Unterrichtsaktivitäten und Bewertungsvorschläge.',
          image: 'https://picsum.photos/seed/factory-res-1/374/217',
        },
        {
          title: 'Szenenbeispiele und Materialien',
          desc: 'Beispiele und Code-Snippets für Förderbandsteuerung, Arbeitsstationsprüfung, Gerätevernetzung usw.',
          image: 'https://picsum.photos/seed/factory-res-2/374/217',
        },
        {
          title: 'Aufgaben für die Vertiefung nach dem Unterricht',
          desc: 'Erweiterungsaufgaben und interdisziplinäre Anwendungsvorschläge zur Förderung von Erkundung und Kreativität.',
          image: 'https://picsum.photos/seed/factory-res-3/374/217',
        },
      ],
      intro: {
        title: 'Produktübersicht',
        desc: 'Das intelligente Fabriksystem konzentriert sich auf den Aufbau von Produktionslinien und Programmsteuerung, einschließlich industrieller Sensorik, Arbeitsstationserkennung, PLC/Mikrocontroller-Steuerung und Datenerfassung, mit Fokus auf praktische Übungen und systematisches Training.',
        bg: 'https://picsum.photos/seed/factory-bg/1200/736',
      },
      course: {
        title: 'Begleitende Kurse',
        desc: 'Projektbasierte Kurse zu Aufbau von Produktionslinien, industrieller Sensorik, PLC-Steuerung und Datenerfassung, mit Schwerpunkt auf Praxis und systematischem Training.',
        image: 'https://picsum.photos/seed/factory-course/668/597',
      },
      equipments: [
        {
          title: 'Förderbandmodul',
          image: 'https://picsum.photos/seed/factory-eq-1/209/209',
        },
        {
          title: 'Fotoelektrischer Sensor',
          image: 'https://picsum.photos/seed/factory-eq-2/209/209',
        },
        {
          title: 'PLC-Steuereinheit',
          image: 'https://picsum.photos/seed/factory-eq-3/209/209',
        },
        {
          title: 'Roboterarmmodul',
          image: 'https://picsum.photos/seed/factory-eq-4/209/209',
        },
        {
          title: 'Barcode-Erkennungsmodul',
          image: 'https://picsum.photos/seed/factory-eq-5/209/209',
        },
        {
          title: 'Temperatur- und Feuchtigkeitssensor',
          image: 'https://picsum.photos/seed/factory-eq-6/209/209',
        },
        {
          title: 'Motorsteuerungsmodul',
          image: 'https://picsum.photos/seed/factory-eq-7/209/209',
        },
        {
          title: 'Arbeitsstationsprüfmodul',
          image: 'https://picsum.photos/seed/factory-eq-8/209/209',
        },
        {
          title: 'Not-Aus-Sicherheitsmodul',
          image: 'https://picsum.photos/seed/factory-eq-9/209/209',
        },
        {
          title: 'Datenerfassungs-Gateway',
          image: 'https://picsum.photos/seed/factory-eq-10/209/209',
        },
      ],
    },
    solutions: {
      title: 'Zetok STEAM-Bildungslösungen',
      learnMore: 'Mehr erfahren >',
      items: [
        {
          image: require('@/assets/home/solution1.webp'),
          title: 'Zetok-Kits',
          description:
            'Durch praktische Übungen und projektbasiertes Lernen werden kreatives Denken und praktische Fähigkeiten gefördert.',
          link: '/solutions/kits',
        },
        {
          image: require('@/assets/home/solution2.webp'),
          title: 'Good Laser Laserschneider & Gravurmaschine',
          description:
            'Laserschneider bieten eine neue praktische Lernerfahrung für STEAM-Bildung.',
          link: '/solutions/laser',
        },
      ],
    },
    scenes: {
      title: 'Lernszenarien',
      items: [
        {
          image: require('@/assets/home/education1.webp'),
          title: 'STEM-Bildungslösungen',
        },
        {
          image: require('@/assets/home/education2.webp'),
          title: 'Makerspace-Lösungen',
        },
      ],
    },
    aiBanner: {
      alt: 'AI Banner',
      image: require('@/assets/home/aibanner.png'),
    },
    kitsSection: {
      alt: 'Zetok-Kits',
      title: 'KI-Kits',
      description:
        'KI-Kits enthalten in der Regel vielfältige interaktive und praktische Projekte, die das Interesse und die Neugier der Schüler an Technologie wecken.',
      image: require('@/assets/home/kitsbanner.png'),
    },
    kitsCarousel: {
      alt: 'Kits Karussell',
      title: 'Förderung von kreativem Denken',
      items: [
        { image: require('@/assets/home/kits1.png') },
        { image: require('@/assets/home/kits2.png') },
        { image: require('@/assets/home/kits3.png') },
        { image: require('@/assets/home/kits4.png') },
        { image: require('@/assets/home/kits5.png') },
        { image: require('@/assets/home/kits6.png') },
        { image: require('@/assets/home/kits7.png') },
        { image: require('@/assets/home/kits8.png') },
        { image: require('@/assets/home/kits9.png') },
      ],
    },
    products: {
      title: 'Zetok-Kits und Good Laser Laserschneider',
      tabs: {
        kits: 'Kits',
        courses: 'Kurse',
        laser: 'Lasergeräte',
        software: 'Software',
      },
      items: {
        kits: [
          {
            image: require('@/assets/home/product1.webp'),
            title: 'Einsteiger-Laserschneid-Kit',
            description: '(inkl. Holzmaterialien)',
          },
          {
            image: require('@/assets/home/product2.webp'),
            title: 'Wissenschaftlicher Entdeckungsbox',
            description: '(inkl. Holz + Mikro-Schaltkreis-Kit)',
          },
          {
            image: require('@/assets/home/product3.webp'),
            title: 'KI-Programmierkit',
            description: '',
          },
        ],
        courses: [
          {
            image: require('@/assets/home/product4.webp'),
            title: 'Wissenschaftliches Entdeckungssystem - Vorschule',
            description: '(6 Kurse)',
          },
          {
            image: require('@/assets/home/product5.webp'),
            title: 'STEAM Makersystem für Jugendliche',
            description: '(3 Kurse)',
          },
          {
            image: require('@/assets/home/product6.webp'),
            title: 'Laserschneidkurs',
            description: '(3 Kurse)',
          },
          {
            image: require('@/assets/home/product7.webp'),
            title: 'KI-Kurs-System',
            description: '(4 Kurse)',
          },
        ],
        laser: [
          {
            image: require('@/assets/home/product8.png'),
            title: 'Light 530',
            description: '55W Desktop CO2 Laserschneider & Gravurmaschine',
          },
          {
            image: require('@/assets/home/product9.png'),
            title: 'Light 640',
            description:
              'Professioneller Desktop-Laserschneider & Gravurmaschine',
          },
          {
            image: require('@/assets/home/product10.png'),
            title: 'Light Blue 530',
            description:
              'Intelligenter Desktop-Blaulicht-Laserschneider & Gravurmaschine',
          },
          {
            image: require('@/assets/home/product11.png'),
            title: 'Mark M20',
            description: 'Hochpräziser Laser-Markierer',
          },
        ],
        software: [
          {
            image: require('@/assets/home/product12.png'),
            title: 'Zetok Lernplattform',
            description: '',
          },
          {
            image: require('@/assets/home/product13.png'),
            title: 'Zetok Cloud-Plattform',
            description: '',
          },
          {
            image: require('@/assets/home/product14.png'),
            title: 'Light Maker',
            description: '',
          },
                    {
            image: require('@/assets/home/product15.png'),
            title: 'mind+',
            description: '',
          },
          {
            image: require('@/assets/home/product16.png'),
            title: 'Arduino',
            description: '',
          },
        ],
      },
    },
  },

  switch_lang: 'English',
  nav: {
    products: 'Produkte',
    smartFarm: 'Intelligenter Bauernhof',
    smartHome: 'Smart Home',
    smartTraffic: 'Intelligenter Verkehr',
    smartFactory: 'Intelligente Fabrik',
    laserSteam: 'Laserschneiden STEAM-Kits',
    dreamScience: 'Dream Science Kits',
    course: 'Kurse',
    device: 'Geräte',
    education: 'Bildungslösungen',
    stem: 'STEM-Bildungslösungen',
    maker: 'Makerspace-Lösungen',
    software: 'Software',
    service: 'Service & Support',
    afterSale: 'Tutorial-Download',
    about: 'Über uns',
    aboutUs: 'Über uns',
    dealer: 'Werden Sie unser Händler',
    cooperation: 'Produktnutzung & Bildungspartnerschaften',
    news: 'Nachrichten',
    coursesSeries: 'Vier Kursreihen',
    viewMore: 'Mehr anzeigen',
    store: 'Shop'
  },
  globalContactForm: {
    title: 'Kontaktieren Sie uns',
    subtitle:
      'Bei Fragen oder Anliegen kontaktieren Sie uns bitte jederzeit. Wir stehen Ihnen gerne zur Verfügung.',
    fields: {
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      company: 'Firma',
      message: 'Nachricht',
    },
    placeholders: {
      name: 'Bitte Namen eingeben',
      email: 'Bitte E-Mail-Adresse eingeben',
      phone: 'Bitte Telefonnummer eingeben',
      company: 'Bitte Firmenname eingeben',
      message: 'Bitte geben Sie Ihr Anliegen oder Ihre Frage ein',
    },
    validation: {
      name: 'Bitte Namen eingeben',
      email: 'Bitte E-Mail-Adresse eingeben',
      emailFormat: 'Ungültiges E-Mail-Format',
      phone: 'Bitte Telefonnummer eingeben',
      message: 'Bitte Nachricht eingeben',
    },
    submit: 'Absenden',
    submitting: 'Wird gesendet…',
    visual: {
      title: 'Professioneller Service',
      description:
        'Wir konzentrieren uns auf die Förderung von technologischem Kreativitätslernen für Kinder von 3 bis 16 Jahren, eröffnen Makerspaces und entwickeln relevante Produkte und Kurse.',
    },
    contact: {
      phone: 'Hotline',
      email: 'E-Mail-Adresse',
    },
  },
  thankYou: {
    metaTitle: 'Danke',
    title: 'Vielen Dank für Ihre Anfrage!',
    description:
      'Wir haben Ihre Informationen erhalten und melden uns so bald wie möglich.',
    seoDescription: 'Eingabe erhalten. Unser Team wird sich bald melden.',
    backHome: 'Zur Startseite',
    browseProducts: 'Produkte durchsuchen',
    contactSupport: 'Support kontaktieren',
    nextStepsTitle: 'Wie geht es weiter',
    nextSteps: [
      'Unser Team prüft Ihre Anfrage innerhalb von 1–2 Werktagen.',
      'Bei Bedarf kontaktieren wir Sie für weitere Details.',
      'Sie können weiter stöbern oder uns per Telefon oder E-Mail erreichen.',
    ],
    contactTitle: 'Benötigen Sie sofortige Hilfe?',
    contactPhoneLabel: 'Service-Hotline:',
    contactEmailLabel: 'E-Mail:',
  },
  about: {
    banner: {
      alt: 'Über uns Banner',
      title:
        'Zetok konzentriert sich auf innovative Bildung und bietet hochwertige Kits und Kurse',
      image: require('@/assets/about/banner.png'),
    },
    mission: {
      title: 'Unsere Mission',
      desc: 'Unsere Mission ist es, durch fortschrittliche KI-Technologie Bildung zu unterstützen, Innovation zu fördern und zukünftige Führungskräfte und Innovatoren zu entwickeln. Wir glauben, dass hochwertige Bildungswerkzeuge und Lösungen Schülern und Lehrkräften helfen, ihr Potenzial auszuschöpfen.',
      image: require('@/assets/about/mission.png'),
    },
    vision: {
      title: 'Unsere Vision',
      desc: 'Technologie befähigt Bildung, unterstützt jeden Schüler beim Zugang zu hochwertigen STEM-Ressourcen, weckt Potenziale und fördert zukünftige Innovatoren und Führungskräfte.',
      image: require('@/assets/about/vision.png'),
    },
    products: {
      title: 'Unsere Produkte',
      tabs: ['Kits', 'Kurse', 'Laserausrüstung'],
      items: [
        {
          title: 'Kits',
          desc: 'Wir bieten vielfältige STEM-Kits, darunter KI, Robotik, Programmierung und wissenschaftliche Experimente. Diese Kits sind sorgfältig gestaltet, benutzerfreundlich und für unterschiedliche Altersgruppen geeignet.',
          image: require('@/assets/about/kits.png'),
        },
        {
          title: 'Kurse',
          desc: 'Unsere Kurse werden von Bildungsexperten entwickelt und sollen in Kombination mit den Kits ein umfassendes Lernerlebnis bieten. Sie decken Grundlagen bis zu fortgeschrittenen Anwendungen ab und sind für Lernende unterschiedlicher Niveaus geeignet.',
          image: require('@/assets/about/courses.png'),
        },
        {
          title: 'Laserausrüstung',
          desc: 'Sichere und benutzerfreundliche Laserschneid- und Gravurgeräte, speziell für Bildungseinrichtungen entwickelt. Diese Geräte bieten Schülern die Möglichkeit, kreative Ideen in physische Werke umzusetzen.',
          image: require('@/assets/about/laser.png'),
        },
      ],
    },
    dealer: {
      banner: {
        alt: 'Werden Sie Zetok-Händler',
        title: 'Werden Sie Zetok-Händler',
        image: require('@/assets/about/dealer.png'),
      },
      intro: {
        title: 'Neue Bildungschancen erschließen, Innovation teilen!',
        desc: 'Zetok lädt Sie ein, neue Wege in der STEM-Bildung zu gehen, bietet KI-Kits, Laserausrüstung und mehr, fördert die Kreativität der Schüler und lädt herzlich zur Zusammenarbeit ein!',
        image: require('@/assets/about/dealer1.png'),
      },
      mission: {
        title: 'Unsere Mission',
        items: [
          {
            title: 'Führende Produkte',
            desc: 'Erhalten Sie hochwertige STEAM-Bildungswerkzeuge auf dem Markt.',
            image: require('@/assets/about/dealer-mission-1.png'),
          },
          {
            title: 'Attraktive Vergütung',
            desc: 'Profitieren Sie von wettbewerbsfähigen Rabatten und Verkaufsanreizen.',
            image: require('@/assets/about/dealer-mission-2.png'),
          },
          {
            title: 'Marktunterstützung',
            desc: 'Wir bieten Marketingmaterialien und Verkaufstraining, um den Markteintritt zu erleichtern.',
            image: require('@/assets/about/dealer-mission-3.png'),
          },
          {
            title: 'Markenpartnerschaft',
            desc: 'Arbeiten Sie mit Zetok zusammen und teilen Sie Markenreichweite und Marktressourcen.',
            image: require('@/assets/about/dealer-mission-4.png'),
          },
        ],
      },
    },
    cooperation: {
      banner: {
        alt: 'Kooperation Banner',
        title: 'Produktkooperation',
        cta: 'Jetzt kontaktieren',
        ctaLink: '/about#contact',
        image: require('@/assets/about/coop-introbanner.png'),
      },
      intro: {
        title: 'Potenzial zukünftiger Wissenschaftler und Ingenieure entfalten',
        desc: 'Treten Sie unserem STEM-Bildungsförderungsprogramm bei, erhalten Sie speziell für Lehrkräfte entwickelte Angebote und Produkttests. Wir bieten innovative STEM-Tools für den Unterricht sowie exklusive Rabatte, um die nächste Generation von Innovatoren und Problemlösern zu fördern.',
        image: require('@/assets/about/coop-introbanner1.png'),
      },
      stem: {
        title:
          'Handeln Sie jetzt und starten Sie ein neues Kapitel der STEM-Bildung!',
        items: [
          {
            title: 'Kostenlose Produkttests',
            desc: 'Testen Sie unsere Tools vor dem Kauf.',
            image: require('@/assets/about/edu1.png'),
          },
          {
            title: 'Exklusive Rabatte',
            desc: 'Erschwingliche STEM-Lösungen für Ihr Klassenzimmer oder Ihre Schule.',
            image: require('@/assets/about/edu2.png'),
          },
          {
            title: 'Lehrmaterialien',
            desc: 'Bieten reichhaltige Unterrichtsmaterialien und Kurspläne zur Unterstützung Ihres Unterrichts.',
            image: require('@/assets/about/edu3.png'),
          },
        ],
      },
      contact: {
        title: 'Kontaktieren Sie uns',
        desc: 'Bei Fragen oder Anliegen kontaktieren Sie uns gerne, wir helfen Ihnen jederzeit.',
        image: require('@/assets/about/kites.png'),
      },
    },
    news: {
      banner: {
        alt: 'News Center Banner',
        title: 'News Center',
        image: require('@/assets/about/newsbanner.png'),
      },
      title: 'News Center',
      tabs: [
        { key: 'company', label: 'Unternehmensnachrichten' },
        { key: 'industry', label: 'Branchennachrichten' },
        { key: 'expo', label: 'Messeberichte' },
      ],
      data: {
        company: [
          {
            id: 'company-1',
            title: 'Zetok stellt neues AI-Klassenzimmer-Kit vor',
            date: '2025-04-22',
            image: 'https://picsum.photos/seed/news-company-1-zh/560/342',
          },
          {
            id: 'company-2',
            title: 'Pilotprojekt STEM mit lokalen Schulen',
            date: '2025-04-15',
            image: 'https://picsum.photos/seed/news-company-2-zh/560/342',
          },
          {
            id: 'company-3',
            title: 'Software-Update verbessert Klassenmanagement',
            date: '2025-03-30',
            image: 'https://picsum.photos/seed/news-company-3-zh/560/342',
          },
          {
            id: 'company-4',
            title: 'Lehrkräfte-Workshop veranstaltet',
            date: '2025-03-18',
            image: 'https://picsum.photos/seed/news-company-4-zh/560/342',
          },
          {
            id: 'company-5',
            title: 'Händlernnetzwerk auf weitere Regionen ausgeweitet',
            date: '2025-03-02',
            image: 'https://picsum.photos/seed/news-company-5-zh/560/342',
          },
          {
            id: 'company-6',
            title: 'Neue Kursreihe fokussiert reale Projekte',
            date: '2025-02-20',
            image: 'https://picsum.photos/seed/news-company-6-zh/560/342',
          },
          {
            id: 'company-7',
            title: 'Jahresrückblick hebt Innovationserfolge hervor',
            date: '2025-02-05',
            image: 'https://picsum.photos/seed/news-company-7-zh/560/342',
          },
          {
            id: 'company-8',
            title: 'Community-Programme bringen STEM zu Jugendlichen',
            date: '2025-01-25',
            image: 'https://picsum.photos/seed/news-company-8-zh/560/342',
          },
        ],
        industry: [
          {
            id: 'industry-1',
            title: 'Globale Trends: Projektbasiertes Lernen in STEM',
            date: '2025-04-10',
            image: 'https://picsum.photos/seed/news-industry-1-zh/560/342',
          },
          {
            id: 'industry-2',
            title: 'KI in der Bildung: Beste Praktiken im Aufkommen',
            date: '2025-03-25',
            image: 'https://picsum.photos/seed/news-industry-2-zh/560/342',
          },
          {
            id: 'industry-3',
            title: 'Neue Lehrpläne betonen praktische Fähigkeiten',
            date: '2025-03-12',
            image: 'https://picsum.photos/seed/news-industry-3-zh/560/342',
          },
          {
            id: 'industry-4',
            title:
              'Bildungshardware stärker auf Klassenzimmerbedürfnisse ausgerichtet',
            date: '2025-02-28',
            image: 'https://picsum.photos/seed/news-industry-4-zh/560/342',
          },
          {
            id: 'industry-5',
            title: 'STEAM-Projekte in allen Schulbezirken fortgesetzt',
            date: '2025-02-14',
            image: 'https://picsum.photos/seed/news-industry-5-zh/560/342',
          },
          {
            id: 'industry-6',
            title: 'Nachhaltigkeitsprojekte erreichen STEM-Klassen',
            date: '2025-01-30',
            image: 'https://picsum.photos/seed/news-industry-6-zh/560/342',
          },
          {
            id: 'industry-7',
            title: 'Makerspaces beeinflussen innovative Lernmethoden',
            date: '2025-01-16',
            image: 'https://picsum.photos/seed/news-industry-7-zh/560/342',
          },
        ],
        expo: [
          {
            id: 'expo-1',
            title: 'Zetok auf Bildungstechnologiemesse präsentiert',
            date: '2025-04-05',
            image: 'https://picsum.photos/seed/news-expo-1-zh/560/342',
          },
          {
            id: 'expo-2',
            title: 'Schülerprojekte auf Regionalmesse vorgestellt',
            date: '2025-03-22',
            image: 'https://picsum.photos/seed/news-expo-2-zh/560/342',
          },
          {
            id: 'expo-3',
            title:
              'Interaktive Demonstrationen auf Makerspace-Events ziehen Aufmerksamkeit an',
            date: '2025-03-08',
            image: 'https://picsum.photos/seed/news-expo-3-zh/560/342',
          },
          {
            id: 'expo-4',
            title: 'Visual Programming Workshop für Lehrkräfte',
            date: '2025-02-21',
            image: 'https://picsum.photos/seed/news-expo-4-zh/560/342',
          },
          {
            id: 'expo-5',
            title: 'Neue Geräte für Bildungspartner präsentiert',
            date: '2025-02-09',
            image: 'https://picsum.photos/seed/news-expo-5-zh/560/342',
          },
        ],
      },
    },
  },
  finance: {
    contact: {
      success:
        'Erfolgreich gesendet. Wir werden uns so schnell wie möglich bei Ihnen melden.',
      error: 'Fehler beim Senden. Bitte versuchen Sie es später erneut.',
      networkError:
        'Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    },
  },

  footer: {
    subscribePlaceholder: 'Ihre Telefonnummer oder E-Mail-Adresse',
    subscribe: 'Abonnieren',
    subscribeSuccess: 'Abonnement erfolgreich',
    contact: {
      sales: 'Vertriebshotline: +86 18379276683',
      service: 'Service-Hotline: +86 400 968 0598',
      email: 'E-Mail: sam@zz-steam.com',
      address:
        'Adresse: Huashengda-Gebäude, Gebäude A, Bagua 4. Straße, Bezirk Futian, Shenzhen',
    },
    icp: 'Datenschutz · Nutzungsbedingungen  Alle Rechte vorbehalten © Zhongze Education (Shenzhen) Co., Ltd. 粤ICP备2024289240号-3',
  },
  solutions: {
    stem: {
      banner: {
        alt: 'STEM-Bildungslösungen Banner',
        title: 'Kreative Führung in der STEM-Bildung',
        description:
          'Für K12 – Wir konzentrieren uns auf kreative STEM-Bildung, wecken Wissbegierde, fördern logisches Denken und entfachen die Begeisterung für das Programmieren.',
        image: require('@/assets/solution/banner.png'),
      },
      intro: {
        title: 'Künstliche Intelligenz & Programmierbildung',
        items: [
          {
            icon: require('@/assets/solution/icon1.png'),
            title: 'Einfach zu lernen und zu nutzen',
            description:
              'Grafische Programmierung – ideal für Einsteiger, sofort startklar für eigene KI-Projekte.',
          },
          {
            icon: require('@/assets/solution/icon2.png'),
            title: 'Leistungsstark',
            description:
              'Intelligente Hardware, Sprachinteraktion, grenzenlose Kreativität.',
          },
          {
            icon: require('@/assets/solution/icon3.png'),
            title: 'Hohe Erweiterbarkeit',
            description:
              'Anschluss externer Module und Hardware – Inspiration entfesseln, unendliche Möglichkeiten schaffen.',
          },
          {
            icon: require('@/assets/solution/icon4.png'),
            title: 'Vielfältige Kurse',
            description:
              'Begleitende Kurse von den Grundlagen bis zur Praxis – systematischer Kompetenzerwerb für Schüler.',
          },
        ],
      },
      scenes: {
        title: 'Unsere特色课程 kennenlernen',
        items: [
          {
            tab: 'Schulunterricht',
            title: 'KI im Schulunterricht',
            desc: 'Mit KI-Kits intelligente Sprachassistenten erstellen, Interesse wecken, Logik- und Programmierfähigkeiten fördern und die Faszination der KI erleben.',
            image: require('@/assets/solution/tc1.png'),
          },
          {
            tab: 'Wettbewerbstraining',
            title: 'Wettbewerbstraining',
            desc: 'Intelligente Kits unterstützen Robotikwettbewerbe und technologische Innovationen, fördern Teamarbeit und Kreativität.',
            image: require('@/assets/solution/tc2.png'),
          },
          {
            tab: 'Lernen zu Hause',
            title: 'Lernen zu Hause',
            desc: 'Eltern-Kind-Lernen von KI-Projekten, Förderung der praktischen Fähigkeiten, Stärkung der Bindung und Verbesserung der digitalen Kompetenz.',
            image: require('@/assets/solution/tc3.png'),
          },
        ],
      },
      split: {
        title: 'KI + Bildung: Start in das Zeitalter des intelligenten Lernens',
        desc: 'Durch KI-gestützte personalisierte Lernpfade und präzisen Unterricht kann jeder Schüler frei im Ozean des Wissens navigieren.',
        image: require('@/assets/solution/banner1.png'),
      },
      kits: {
        title: 'STEM-Serienkits',
        images: [
          require('@/assets/solution/kits1.png'),
          require('@/assets/solution/kits2.png'),
          require('@/assets/solution/kits3.png'),
          require('@/assets/solution/kits4.png'),
        ],
      },
    },
    makerSpace: {
      banner: {
        alt: 'Makerspace-Lösungen Banner',
        title: 'Entdecken Sie unseren Makerspace',
        description:
          'Im Makerspace verschmelzen Bildung und innovative Technologie und bieten Schülern eine Plattform zum praktischen Experimentieren und Forschen.',
        image: require('@/assets/solution/spacebanner.png'),
      },
      intro: {
        title: 'Ganzheitliche Maker-Fähigkeiten',
        items: [
          {
            icon: require('@/assets/solution/icon5.png'),
            title: 'Anwendung technischer Werkzeuge',
            desc: 'Grafische Programmierung – einfach zu starten, ideal für den schnellen Einstieg in KI-Projekte.',
          },
          {
            icon: require('@/assets/solution/icon6.png'),
            title: 'Offenheit und Flexibilität',
            desc: 'Makerspace – frei erkunden, der exklusive Spielplatz für Kreativität.',
          },
          {
            icon: require('@/assets/solution/icon7.png'),
            title: 'Praktisches Arbeiten',
            desc: 'Selber machen, fertigen, experimentieren, entdecken – die Reise des Lernens beginnt.',
          },
          {
            icon: require('@/assets/solution/icon8.png'),
            title: 'Kooperatives Lernen',
            desc: 'Fördert Teamarbeit und Kommunikationsfähigkeit durch gemeinsames Arbeiten.',
          },
        ],
      },
      scenes: {
        title: 'Anwendungsszenarien des Makerspace',
        items: [
          {
            tab: 'Schulische Handwerkskurse',
            title: 'Schulische Handwerkskurse',
            desc: 'Eine wirkungsvolle Ergänzung für Handwerks-, Kunst- und Designkurse.',
            image: require('@/assets/solution/tc4.png'),
          },
          {
            tab: 'Forschungs-AGs',
            title: 'Forschungs-AGs',
            desc: 'Praxisplattform für schulische Innovations- und Forschungsgruppen.',
            image: require('@/assets/solution/tc5.png'),
          },
          {
            tab: 'Bildungslabore',
            title: 'Bildungslabore',
            desc: 'Geeignet für Schulen, Universitäten oder Labore mit professionellen Lasergravurgeräten.',
            image: require('@/assets/solution/tc6.png'),
          },
        ],
      },
      split: {
        title: 'Werkzeuge zur Umsetzung von Kreativität',
        desc: 'Dank präziser Laserschneidtechnik und intelligenter Interaktion von Programmierrobotern können Schüler abstrakte Ideen in reale Werke umsetzen.',
        image: require('@/assets/solution/banner2.png'),
      },
      kits: {
        title: 'Maker-Serienkits',
        images: [
          require('@/assets/solution/kits5.png'),
          require('@/assets/solution/kits6.png'),
          require('@/assets/solution/kits7.png'),
          require('@/assets/solution/kits8.png'),
        ],
      },
    },
  },
  software: {
    banner: {
      alt: 'Softwareseite Banner',
      title: 'Zetok Software-Zentrum',
      image: require('@/assets/software/banner.png'),
    },
    download: {
      title: 'Software-Downloads',
      items: [
        {
          key: 'lightmaker-app',
          icon: 'https://picsum.photos/seed/sw-app-1/88/88',
          name: 'Light Maker App',
          buttonText: 'Mobile Version herunterladen',
          link: '#',
        },
        {
          key: 'goodlaser-lightmaker',
          icon: 'https://picsum.photos/seed/sw-app-2/88/88',
          name: 'Good-laser Light Maker',
          buttonText: 'Desktop-Version herunterladen',
          link: '#',
        },
        {
          key: 'zz-learning-app',
          icon: 'https://picsum.photos/seed/sw-app-3/88/88',
          name: 'Zhongze Lernplattform App',
          buttonText: 'Mobile Version herunterladen',
          link: '#',
        },
        {
          key: 'zz-learning-platform',
          icon: 'https://picsum.photos/seed/sw-app-4/88/88',
          name: 'Zhongze Technologie-Lernplattform',
          buttonText: 'Desktop-Version herunterladen',
          link: '#',
        },
      ],
    },
    intro: {
      'goodlaser-lightmaker': {
        header: {
          title: 'Light Maker – Spezielle Software für Lasergeräte',
          desc: 'Integriert Grafikdesign und Gerätesteuerung in einem System und bietet eine umfassende Lösung für Design und Lasersteuerung.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-1/514/403',
            title: 'Leistungsstarkes und benutzerfreundliches Designsystem',
            desc: 'Kompatibel mit JPG, DXF, AI, DST, PNG, BMP, TIF und SVG für hochwertige Designs.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-2/514/403',
            title: 'Professionelle Funktionalität',
            desc: 'Professionelle Zeichenfunktionen für alle Anforderungen – von komplexen Designs bis zu einfachen Schnitten.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-3/514/403',
            title: 'Einfache Bedienung',
            desc: 'Benutzerfreundliche Oberfläche, unterstützt mehrere Lasergeräte, hohe Schneide- und Gravureffizienz.',
          },
        ],
      },
      'lightmaker-app': {
        header: {
          title: 'Zetok Cloud-Plattform',
          desc: 'Eine innovative Bildungsverwaltungsplattform für Lehrer, Schüler und Schulen zur zentralen Aufgaben-, Geräte- und Wartungsverwaltung.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-app-1/514/403',
            title: 'Bequeme Bedienung',
            desc: 'Ein-Klick-Produktion mit integrierter Materialbibliothek und Parameterkonfiguration, Echtzeit-Geräteüberwachung.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-2/514/403',
            title: 'Zentrale Verwaltung',
            desc: 'Unterstützt die zentrale Verwaltung mehrerer Geräte im Makerspace.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-3/514/403',
            title: 'Echtzeit-Überwachung',
            desc: 'Überwachung des Gerätestatus, rechtzeitige Wartung und verlängerte Lebensdauer.',
          },
        ],
      },
      'zz-learning-app': {
        header: {
          title: 'Zhongze Lernplattform App – Softwarebeschreibung',
          desc: 'Mobile Plattform für Lernen, Übung und Bewertung. Platzhaltertext, kann später aktualisiert werden.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-1/514/403',
            title: 'Intelligent und benutzerfreundlich',
            desc: 'Reichhaltige Materialbibliothek, voreingestellte Parameter und Ein-Klick-Produktion für schnellen Einstieg.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-2/514/403',
            title: 'KI-gestützte Erstellung',
            desc: 'Einfache Eingaben reichen aus, um automatisch hochwertige, schnittfertige Materialien zu generieren.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-3/514/403',
            title: 'Effizientes Lernerlebnis',
            desc: 'Vereint Kurslernen, Grafikdesign und Laserschneiden in einer Plattform für maximale Lerneffizienz.',
          },
        ],
      },
      'zz-learning-platform': {
        header: {
          title: 'Zhongze Technologie-Lernplattform – Softwarebeschreibung',
          desc: 'Integrierte Plattform für Kursverwaltung, Aufgabenverteilung und Analyse. Aktuell als Platzhaltertext.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-1/514/403',
            title: 'Kursverwaltung & Veröffentlichung',
            desc: 'Zentrale Verwaltung von Lehrinhalten und Materialien.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-2/514/403',
            title: 'Unterrichtsdatenanalyse',
            desc: 'Visualisierte Lerndaten zur Unterstützung von Lehrentscheidungen.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-3/514/403',
            title: 'Multi-Endgeräte-Synchronisation',
            desc: 'Zusammenarbeit von App, Geräten und Webplattform.',
          },
        ],
      },
    },
  },

  product: {
    farm: {
      banner: {
        alt: 'Smart-Farm-Banner',
        title: 'Smart-Farm-Lernkit',
        btnText: 'Jetzt kaufen',
        description:
          'Projektbasiertes Lernen | Programmierung + Hardware + KI | Geeignet für Grund- und Sekundarstufe',
        image: require('@/assets/product/farm/banner.png'),
      },
      sections: {
        courseTitle: 'Projektkurs-Inhalte',
        resourceTitle: 'Lehrmaterialien',
        equipmentsTitle: 'Gerätekonfiguration',
      },
      courses: [
        {
          bg: '#FBBC05',
          txt: '#fff',
          title: 'Vielfältige Kursinhalte',
          desc: '12 Lektionen vom Einfachen zum Fortgeschrittenen: von Temperaturmessung bis intelligenter Bewässerung und Temperaturregelung – nahtlose Progression.',
          image: require('@/assets/product/farm/education1.png'),
        },
        {
          bg: '#4285F4',
          txt: '#fff',
          title: 'Interdisziplinäre Wissensintegration',
          desc: 'Jedes Projekt umfasst Programmierung, elektronische Hardware, mechanische Strukturen u. a.; unterstützt die praktische Anwendung des Gelernten und fördert interdisziplinäres Denken.',
          image: require('@/assets/product/farm/education2.png'),
        },
        {
          bg: '#EA4335',
          txt: '#fff',
          title: 'Alltagsnahe Themen',
          desc: 'Das Thema Smart Farm ist lebensnah und weckt leicht Lerninteresse und Beteiligung.',
          image: require('@/assets/product/farm/education3.png'),
        },
      ],
      resources: [
        {
          title: 'Vollständige Unterrichts-PPTs und Handouts',
          desc: 'Unterrichts-PPTs und Handouts für 16 Lektionen, eng auf die Projekte abgestimmt; reichhaltige Materialien für Lehrkräfte, weniger Vorbereitungsaufwand.',
          image: require('@/assets/product/farm/edu1.png'),
        },
        {
          title: 'Montagevideos zu projektbasierten Kursen',
          desc: 'Videos zeigen den Aufbau der Projekte anschaulich, helfen Schülern Abläufe besser zu verstehen und steigern die Lern­effizienz.',
          image: require('@/assets/product/farm/edu2.png'),
        },
        {
          title: 'Begleitende Lehrmaterialien',
          desc: 'Handouts und weitere Materialien bieten detaillierte Lernhinweise und erleichtern Nachbereitung wie auch Selbststudium.',
          image: require('@/assets/product/farm/edu3.png'),
        },
      ],
      equipments: [
        {
          title: 'RGB‑Lichtstreifen',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307‑Uhrmodul',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11‑Temperatur‑ und Feuchtigkeitssensor',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Bewegungssensor',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED‑Beleuchtungsmodul',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Lüftermodul',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Schlitz‑Optokoppler‑Schalter',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Tastenmodul',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Controller‑Board',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Erweiterungsboard',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    home: {
      banner: {
        alt: 'Smart‑Home‑Lernkit',
        title: 'Smart‑Home‑Lernkit',
        btnText: 'Jetzt kaufen',
        description:
          'Programmierung & KI‑Einführung | Projektbasiertes Lernen | Erste Wahl für Technikunterricht in Grund‑ und Sekundarstufe',
        image: require('@/assets/product/home/banner.png'),
      },
      resourcesTitle: 'Vorteile des Smart‑Home‑Einsteigerkits',
      resources: [
        {
          title: 'Umfangreiche Ressourcen',
          desc: 'Bietet vollständige Lehrressourcen und erleichtert Lehren wie Lernen.',
          image: require('@/assets/product/home/adv1.png'),
        },
        {
          title: 'Interdisziplinäre Integration',
          desc: 'Jedes Projekt umfasst Programmierung, elektronische Hardware, mechanische Strukturen u. a.; fördert die praktische Anwendung und interdisziplinäres Denken.',
          image: require('@/assets/product/home/adv2.png'),
        },
        {
          title: 'Aufgaben zur Nachbereitung',
          desc: 'Erweiterungsaufgaben und interdisziplinäre Anwendungsvorschläge fördern Erkundung und Kreativität.',
          image: require('@/assets/product/home/adv3.png'),
        },
      ],
      course: {
        title: 'Begleitende Kurse',
        desc: 'Enthält 12 hochwertige Projektkurse zu Smart‑Home‑Themen wie elektronischer Türgong, dimmbare Vorplatzbeleuchtung, Sensorgarage, PIN‑Zugang, Gaswarnung, Einbruchalarm, farbenfrohe Lichter, Musik‑Ambientelicht, Lichtdetektion, Raumtemperaturmessung und temperaturgeregelter Ventilator.',
        image: require('@/assets/product/home/banner2.png'),
      },
      scenesTitle: 'Vielfältige Anwendungsszenarien',
      scenes: [
        {
          title: 'Unterricht im Klassenzimmer',
          image: require('@/assets/product/home/c1.png'),
        },
        {
          title: 'Eigenständige kreative Entwicklung',
          image: require('@/assets/product/home/c2.png'),
        },
        {
          title: 'Familien‑ und Eltern‑Kind‑Interaktion',
          image: require('@/assets/product/home/c3.png'),
        },
        {
          title: 'Event‑Präsentationen',
          image: require('@/assets/product/home/c4.png'),
        },
      ],
      equipmentsTitle: 'Gerätekonfiguration',
      equipments: [
        {
          title: 'RGB‑Lichtstreifen',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307‑Uhrmodul',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11‑Temperatur‑ und Feuchtigkeitssensor',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Bewegungssensor',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED‑Beleuchtungsmodul',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Lüftermodul',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Schlitz‑Optokoppler‑Schalter',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Tastenmodul',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Controller‑Board',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Erweiterungsboard',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    factory: {
      banner: {
        alt: 'Smart‑Factory‑Banner',
        title: 'Smart‑Factory‑Lernkit',
        btnText: 'Jetzt kaufen',
        description: ` · Vollständige Abdeckung von Sensorik/Steuerung/Antrieb <br>
 · Simulation realer Produktionslinien<br>
 · Ausbildung „zukünftiger Ingenieure“`,
        image: require('@/assets/product/factory/banner.png'),
      },
      resourcesTitle: 'Produktmerkmale',
      resources: [
        {
          title: 'Kern‑Erlebnis von Industrie 4.0',
          desc: 'Schüler trainieren Sensorik, Steuerung, Antrieb und Datenmanagement in einer simulierten Produktionslinie.',
          image: require('@/assets/product/factory/tc1.png'),
        },
        {
          title: 'Projektbasiertes Lernen',
          desc: 'Umfasst Programmier‑Tutorials sowie 12 Kurseinheiten mit PPT und erleichtert das Lernen.',
          image: require('@/assets/product/factory/tc2.png'),
        },
        {
          title: 'Simulation realer Szenarien',
          desc: 'Intelligenter Roboterarm, automatisches Klassifikationssystem, Smart‑Warehouse; simuliert Logistik‑ und Bestandsmanagement und startet die STEM‑Praxisreise.',
          image: require('@/assets/product/factory/tc3.png'),
        },
      ],
      intro: {
        title: 'Produktvorstellung',
        desc: 'Das Smart‑Factory‑Lernset ist ein projektbasiertes Unterrichts‑Kit, das Programmierung, elektronische Hardware, mechanische Strukturen, Laserschneiden und Einführung in künstliche Intelligenz kombiniert. Geeignet für Einsatz und Unterricht in Grund‑ und Sekundarstufe. Unter dem Thema „Intelligente Fertigung · Zukunft gestalten“ fördern simulierte Produktionsumgebungen wissenschaftliche Exploration, Ingenieurgestaltung, Programmiersteuerung und kollaborative Innovation.',
        bg: require('@/assets/product/factory/product.png'),
      },
      course: {
        title: 'Begleitende Kurse',
        desc: '12 Premium‑Kurse: abdeckend Smart‑Factory‑Einstieg, Verständnis von Produktionsprozessen, Sensoranwendungen, Grundlagen des mechanischen Antriebs, Aufbau von Fördersystemen, automatische Sortierung, kollaborative Steuerung von Arbeitsstationen, Montage eines Roboterarms, intelligente Sortierung u. a. Projektkurse zu Steuerung und Datenerfassung betonen praktische Übungen und systematisches Training.',
        image: require('@/assets/product/factory/course.png'),
      },
      equipmentsTitle: 'Gerätekonfiguration',
      equipments: [
        {
          title: 'RGB‑Lichtstreifen',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307‑Uhrmodul',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11‑Temperatur‑ und Feuchtigkeitssensor',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Bewegungssensor',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED‑Beleuchtungsmodul',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Lüftermodul',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Schlitz‑Optokoppler‑Schalter',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Tastenmodul',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Controller‑Board',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Erweiterungsboard',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    kits: {
      laserSteam: {
        banner: {
          alt: 'Laser-Schneiden STEAM-Kit Banner',
          title: 'Laser-Schneiden STEAM-Kit',
          btnText: 'Jetzt kaufen',
          description:
            'Ganzheitliche Lösung für die Förderung von Innovationsdenken und Teamarbeit in der Maker-Bildung',
          image: require('@/assets/product/laser-steam/banner.png'),
        },
        aiBanner: {
          title: 'KI-Bildung, smarter Start',
          desc: 'STEAM-Bildung mit KI-Elementen verbinden und ein ganzheitliches Lernerlebnis schaffen.',
        },
        resourcesTitle: 'Vorteile des Laser-Schneiden STEAM-Kits',
        resources: [
          {
            title: 'Theorie der multiplen Intelligenzen',
            desc: 'Basierend auf der Theorie der multiplen Intelligenzen fördert der Unterricht Kreativität, kritisches Denken, Problemlösungs- sowie Kommunikations- und Kooperationsfähigkeiten.',
            image: require('@/assets/product/laser-steam/adv1.png'),
          },
          {
            title: 'Projektbasiertes Lernen',
            desc: 'Durch projektbasiertes Lernen können Schülerinnen und Schüler in der Praxis lernen und so Effizienz und Lerninteresse steigern.',
            image: require('@/assets/product/laser-steam/adv2.png'),
          },
          {
            title: 'STEAM-Bildung',
            desc: 'Die Kursinhalte integrieren Wissen aus Wissenschaft, Technik, Ingenieurwesen, Kunst und Mathematik, um interdisziplinäres Denken zu fördern.',
            image: require('@/assets/product/laser-steam/adv3.png'),
          },
        ],
        teach: {
          title: 'Detaillierte begleitende Lehre',
          tabs: [
            { key: 'cutter', label: 'Laserschneider' },
            { key: 'lesson', label: 'Begleitkurse' },
            { key: 'material', label: 'Unterrichtsmaterialien' },
            { key: 'software', label: 'Software' },
          ],
          images: {
            cutter: require('@/assets/product/laser-steam/cutter.png'),
            lesson: require('@/assets/product/laser-steam/lesson.png'),
            material: require('@/assets/product/laser-steam/material.png'),
            software: require('@/assets/product/laser-steam/software.png'),
          },
        },
        equipmentsTitle: 'Ausstattung',
      },

      // Dream Science Kit
      dreamScience: {
        banner: {
          alt: 'Dream Science Kit Banner',
          title: 'Wundervolle Wissenschaftsbox (Dream Science Kit)',
          description:
            'Grundlagen der Wissenschaft | Wissenschaftliches Denken | Forschendes Lernen | Haltung & Verantwortung',
          image: require('@/assets/product/dream-science/banner.png'),
        },
        resourcesTitle: 'Kit-Inhalte',
        resources: [
          {
            title: 'Materialien für wissenschaftliche Experimente',
            desc: 'Zur Durchführung verschiedener wissenschaftlicher Experimente und Projekte.',
            image: require('@/assets/product/dream-science/kits1.png'),
          },
          {
            title: 'Unterrichtsressourcen',
            desc: 'Enthält Unterrichts-PPTs und Skripte zur Unterstützung eines gesamten Semesters, eng abgestimmt auf Projekte und Lerninhalte.',
            image: require('@/assets/product/dream-science/kits2.png'),
          },
          {
            title: 'Montagevideos und Skripte',
            desc: 'Begleitende Unterrichtsmaterialien, die den Schülerinnen und Schülern helfen, die Arbeitsschritte besser zu verstehen und zu beherrschen.',
            image: require('@/assets/product/dream-science/kits3.png'),
          },
        ],
        objectivesTitle: 'Lernziele',
        objectives: [
          {
            title: 'Wissenschaftliche Forschungskompetenz',
            desc: 'Fragen stellen, Pläne erstellen, Daten sammeln und analysieren',
            image: require('@/assets/product/dream-science/education1.png'),
          },
          {
            title: 'Ingenieurpraktische Fähigkeiten',
            desc: 'Handwerklicher Aufbau und Tests, iterative Optimierung von Lösungen',
            image: require('@/assets/product/dream-science/education2.png'),
          },
          {
            title: 'Interdisziplinäre Integration',
            desc: 'Projekte unter Einbeziehung von Mathematik, Physik und Kunst',
            image: require('@/assets/product/dream-science/education3.png'),
          },
        ],
        intro: {
          title: 'Zielgruppe',
          description:
            'Schülerinnen und Schüler der Primar- und Sekundarstufe: Geeignet für verschiedene Altersgruppen zur Förderung wissenschaftlicher Kompetenz und praktischer Fähigkeiten. Lehrkräfte: Bereitstellung von Unterrichtsressourcen und Anleitung zur besseren Durchführung des Unterrichts.',
          image: require('@/assets/product/dream-science/banner1.png'),
          alt: 'Bild des Einführungsbereichs',
        },
      },
    },

    // Seite „Alle Kits anzeigen“
    kitsViewAll: {
      banner: {
        alt: 'Alle Kits anzeigen Banner',
        title: 'Kit-Serie',
        image: require('@/assets/product/kitsall/banner.png'),
      },
      contentTitle:
        'Projektorientiert lernen – durch die Bearbeitung verschiedener Projektaufgaben entwickeln die Schüler die Fähigkeit, Wissen umfassend zur Problemlösung einzusetzen.',
      moreText: 'Mehr erfahren',
      items: [
        {
          image: require('@/assets/product/kitsall/kits1.png'),
          title: 'Smart-Farm-Lernkit',
          desc: 'Projektorientierter Ansatz zur Förderung von Kreativität und praktischen Fähigkeiten sowie der Fähigkeit, reale Probleme zu lösen.',
          link: '/products/laser-steam',
        },
        {
          image: require('@/assets/product/kitsall/kits2-1.png'),
          title: 'Smart-Home-Lernkit',
          desc: 'Kombiniert Programmierung, Elektronik, Mechanik, Laserschneiden und KI-Grundlagen für ein umfassendes Lernerlebnis.',
          link: '/products/dream-science',
        },
        {
          image: require('@/assets/product/kitsall/kits2-2.png'),
          title: 'Intelligentes Verkehrssystem-Lernkit',
          desc: 'Ein projektorientiertes Lernkit, das Programmierung, Elektronik, Mechanik, Laserschneiden und KI-Grundlagen vereint.',
          link: '/products',
        },
        {
          image: require('@/assets/product/kitsall/kits2-3.png'),
          title: 'Smart-Factory-Lernkit',
          desc: 'Deckt Grundlagen der Künstlichen Intelligenz und praxisnahe Fallbeispiele ab und führt die Lernenden systematisch in den Wissensaufbau ein.',
          link: '/products/traffic',
        },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Laser-Schneiden STEAM-Kit',
        //   desc: 'Das STEAM-Laserkit basiert auf der Theorie der multiplen Intelligenzen, der STEAM-Bildung und dem projektbasierten Lernen.',
        //   link: '/products/home',
        // },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Dream Science Kit',
        //   desc: 'Das Dream Science Kit deckt die Anforderungen verschiedener Lernstufen ab und fördert das wissenschaftliche Interesse sowie den Entdeckergeist der Schüler.',
        //   link: '/products/farm',
        // },
      ],
    },

    traffic: {
      banner: {
        alt: 'Intelligenter Verkehr Banner',
        title: 'Intelligentes Verkehrssystem-Lernkit',
        btnText: 'Jetzt kaufen',
        description: `12 projektbasierte Kurse 
<br>· Grafische/Python-Doppelprogrammierung  <br>
· Simulation realer Szenarien<br>
· Sofort einsatzbereit für den Unterricht`,
        image: require('@/assets/product/traffic/banner.png'),
      },
      resourcesTitle: 'Produktmerkmale',
      resources: [
        {
          title: 'Wissenschaftliche Forschung & Innovation',
          desc: 'Schüler bauen intelligente Verkehrssysteme mit elektronischen Modulen und mechanischen Strukturen',
          image: require('@/assets/product/traffic/traffic1.png'),
        },
        {
          title: 'Hoher Bildungswert',
          desc: 'Ermöglicht den Bau von intelligenten Straßenlaternen, Ampeln, Zebrastreifen und Parkplätzen, um Konzepte des intelligenten Verkehrs zu vermitteln.',
          image: require('@/assets/product/traffic/traffic2.png'),
        },
        {
          title: 'Umfangreiche Ressourcen',
          desc: 'Vollständige Unterrichtsmaterialien inklusive PPTs und Skripten für 12 Unterrichtseinheiten sowie Montagevideos und Begleitunterlagen.',
          image: require('@/assets/product/traffic/traffic3.png'),
        },
      ],
      intro: {
        title: 'Produktbeschreibung',
        desc: 'Das intelligente Verkehrssystem-Kit für Grund- und Sekundarschulen steht unter dem Thema „Intelligente Mobilität“ und „Verkehrssicherheit“. Es kombiniert elektronische Steuerung, Sensorik und weitere Technologien, um Schüler anzuleiten, selbst intelligente Verkehrssysteme zu entwerfen und zu bauen, reale Verkehrsszenarien zu simulieren und wissenschaftliche Kompetenz sowie Innovationsfähigkeit zu fördern.',
        bg: require('@/assets/product/traffic/banner1.png'),
      },
      course: {
        title: 'Begleitende Kurse',
        desc: 'Enthält projektbasierte Kurse zu Verkehrswahrnehmung und -steuerung, Signalverknüpfung, Routenplanung und weiteren Themen, angepasst an verschiedene Lernstufen und Unterrichtszeiten.',
        image: require('@/assets/product/traffic/course.png'),
      },
      equipmentsTitle: 'Ausstattung',
      equipments: [
        {
          title: 'RGB-LED-Streifen',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307 Echtzeituhr-Modul',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11 Temperatur- und Feuchtigkeitssensor',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Bewegungssensor',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED-Beleuchtungsmodul',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Lüftermodul',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Gabellichtschranke',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Tastermodul',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Steuerboard',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Erweiterungsboard',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    banner: {
      alt: 'Produkt-Startseitenbanner',
      title: 'Zetok Produkte & Lösungen',
      description:
        'Kits, Kurse, Geräte und Software in einem – Unterstützung für projektbasiertes Lernen',
      image: 'https://picsum.photos/id/1069/1600/900',
    },

    courses: {
      banner: {
        alt: 'Kurskomponenten-Banner',
        title: 'Vier große Kurssysteme',
        description:
          'Die Kursinhalte decken mehrere Fachbereiche wie Wissenschaft, Technik, Ingenieurwesen, Kunst und Mathematik (STEAM) ab und fördern die Integration sowie Anwendung interdisziplinären Wissens.',
        image: require('@/assets/product/courses/banner.png'),
      },
      design: {
        title: 'Unsere charakteristischen Kurse kennenlernen',
        nav: [
          'Alter 3–6 Jahre',
          'Alter 6–12 Jahre',
          'Alter 8–13 Jahre',
          'Alter 9–15 Jahre',
        ],
        entries: [
          {
            title:
              'System für wissenschaftliche Entdeckungen · Kindergarten (6 Kurse)',
            desc: 'Ausgehend von alltäglichen Phänomenen werden mit didaktischen Materialien wissenschaftliche Zusammenhänge und Prinzipien erforscht.',
            image: require('@/assets/product/courses/courses1.png'),
          },
          {
            title: 'STEAM-Maker-System für Jugendliche (3 Kurse)',
            desc: 'Fördert Kreativität, den Umgang mit Geräten und die Umsetzung von Ideen durch praktisches Arbeiten.',
            image: require('@/assets/product/courses/courses2.png'),
          },
          {
            title: 'Kurssystem für Laserschneiden (3 Kurse)',
            desc: 'Nutzung der Geräte zum Schneiden verschiedener Bauteile, Zusammenbau dreidimensionaler Strukturen und deren Gestaltung. Programmierkompetenz: Verständnis der Logik und Prinzipien von Programmierentscheidungen.',
            image: require('@/assets/product/courses/courses3.png'),
          },
          {
            title: 'Kurssystem für Künstliche Intelligenz (4 Kurse)',
            desc: 'Gestaltung des äußeren Erscheinungsbildes von Projekten mit Geräten und Werkzeugen sowie deren intelligente Steuerung durch Programmierung zur Lösung realer Alltagsprobleme. ',
            image: require('@/assets/product/courses/courses4.png'),
          },
        ],
        detailsTitle: 'Kurvorteile',
        details: [
          {
            title: 'Starke Praxisorientierung',
            description: 'Handwerkliches Lernen – Theorie wird zur Fähigkeit',
            image: require('@/assets/product/courses/icon1.png'),
          },
          {
            title: 'Förderung von Innovationsdenken',
            description: 'Kreatives Design zur Problemlösung',
            image: require('@/assets/product/courses/icon2.png'),
          },
          {
            title: 'Projektorientiertes Lernen',
            description: 'Wissensvermittlung durch praxisnahe Projektarbeit',
            image: require('@/assets/product/courses/icon3.png'),
          },
          {
            title: 'Erkundung technologischer Spitzenbereiche',
            description: 'Am Puls der Technik – Lernen mit intelligenten Kits',
            image: require('@/assets/product/courses/icon4.png'),
          },
          {
            title: 'Systematischer Unterricht',
            description: 'Vom Fundament bis zur Praxis – schrittweiser Aufbau',
            image: require('@/assets/product/courses/icon5.png'),
          },
          {
            title: 'Spaß und Herausforderung zugleich',
            description:
              'Interesse durch Spaß, Potenzial durch Herausforderung – Wachstum durch Entdeckungen. ',
            image: require('@/assets/product/courses/icon6.png'),
          },
        ],
      },
      ai: {
        title: 'Kursreihe Künstliche Intelligenz',
        items: [
          {
            name: 'Smart Farm',
            image: require('@/assets/product/courses/courses5.png'),
          },
          {
            name: 'Smart Home',
            image: require('@/assets/product/courses/courses6.png'),
          },
          {
            name: 'Intelligenter Verkehr',
            image: require('@/assets/product/courses/courses7.png'),
          },
          {
            name: 'Smart Factory',
            image: require('@/assets/product/courses/courses8.png'),
          },
        ],
      },
      aiBanner: {
        alt: 'KI-Kurs-Banner',
        text: 'Projektbasiert, interdisziplinär, Förderung von Praxis, Teamarbeit und Problemlösung. Sicherheit und Individualität im Fokus, Präsentationen steigern das Erfolgserlebnis und unterstützen das Wachstum der Schüler.',
        image: require('@/assets/product/courses/banner1.png'),
      },
    },

    laser: {
      banner: {
        alt: 'Laserprodukte',
        title: 'Good Laser Laserprodukte',
        description:
          'Sichere und benutzerfreundliche Laser-Schneid- und Graviergeräte sowie Lösungen für Bildungsszenarien',
        image: require('@/assets/product/laser/banner.png'),
      },
      advantagesTitle: 'Unsere Vorteile',
      extraNote: {
        light640_640:
          'Hervorragende Schneid- und Gravurergebnisse\nMehrere Modelle mit verschiedenen Laserleistungsoptionen zur Erfüllung unterschiedlicher Anwendungsanforderungen\nLasertyp: DC-CO2  Laserleistung: 60W–130W',
      },
      center: {
        title: 'Produktzentrum',
        laser_accessories: 'Laserzubehör',
        air_purifier_name: 'Luftreiniger',
        description:
          'Wir bieten abgestimmte Lasergeräte-Lösungen entsprechend dem unterschiedlichen Unterrichtsniveau der Schulen an. Zetok hat vier offizielle Lasergeräte-Lösungen eingeführt, aus denen Schulen je nach tatsächlichem Unterrichtsbedarf auswählen können.',
        tabs: [
          {
            key: 'light530',
            label: 'Light 530',
            images: [
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Hochwertiger und hochpräziser Laser',
                bgColor: '#4285F4',
                description:
                  'Verdicktes, hochwertiges CO₂-Laserrohr mit einer Wellenlänge von 10640 nm, das 55 W hochwertigen CO₂-Laser liefert. Maximale Schnittdicke bis zu 20 mm (Acryl), Arbeitsgeschwindigkeit bis 600 mm/s und Wiederholgenauigkeit von 0,025 mm – ideal für schnelles und präzises Schneiden und Gravieren feiner kreativer Werke.',
                image: require('@/assets/product/laser/light530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Integrierter dreistufiger Abgasfiltersystemkasten',
                bgColor: '#FFBC0C',
                description:
                  'Integriertes Design mit Filter, Aktivkohle und UV-Ozonschicht zur Rauch- und Staubfiltration. Sauberer und umweltfreundlicher, zugleich platzsparend und kompakt – kein zusätzlicher Filterkasten erforderlich.',
                image: require('@/assets/product/laser/light530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Höchste Priorität bei Sicherheitsstandards',
                bgColor: '#34A853',
                description:
                  'Bestanden die höchsten Sicherheitstests eines SGS-Labors, FDA-zertifiziertes Laserprodukt der Klasse I. Einzigartiges Design mit Sicherheits- und Betriebsstatusanzeigen zur klaren und direkten Überwachung des Maschinenzustands.',
                image: require('@/assets/product/laser/light530-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title:
                  'Einfache Bedienung und leistungsstarkes Laserschneidsystem',
                bgColor: '#0F9D58',
                description:
                  '· Unterschiedliche Bearbeitungsparameter je nach Material einstellbar (Schneiden, Tiefgravur, Flachgravur, Scannen usw.). · Umfangreiche Vorlagen erhöhen die Designeffizienz. · Kamera unterstützt punktgenaue Aufnahmen zur Designunterstützung und macht kreative Ideen realisierbar.',
                image: require('@/assets/product/laser/light530-4.png'),
              },
            ],
          },
          {
            key: 'light640',
            label: 'Light 640',
            images: [
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
            ],
            models: [
              {
                key: '640',
                label: 'Light 640',
                image: require('@/assets/product/laser/640.png'),
              },
              {
                key: '960',
                label: 'Light 960',
                image: require('@/assets/product/laser/960.png'),
              },
              {
                key: '1390',
                label: 'Light 1390',
                image: require('@/assets/product/laser/1390.png'),
              },
              {
                key: '1610',
                label: 'Light 1610',
                image: require('@/assets/product/laser/1610.png'),
              },
            ],
            modelAdvantages: {
              640: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Arbeitsbereich',
                  bgColor: '#4285F4',
                  description: `Light640 (600*400mm)
Light960 (900*600mm)
<br>Light1390 (1300*900mm)
<br>Light1610 (1600*1000mm)`,
                  image: require('@/assets/product/laser/640-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Effizienter Autofokus + Rotpunkt-Positionierung',
                  bgColor: '#FFBC0C',
                  description:
                    'Die Autofokus-Funktion ermöglicht eine schnelle und präzise Fokussierung vor dem Schneiden und Gravieren. In Kombination mit der Rotpunkt-Positionierung kann die Arbeitsposition in Echtzeit angezeigt werden, was Zeit spart und bessere Ergebnisse liefert.',
                  image: require('@/assets/product/laser/640-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Offenes Heckdesign',
                  bgColor: '#34A853',
                  description:
                    'Das offene Heckdesign ermöglicht das Einlegen von Materialien mit unbegrenzter Länge. Platten von 600 mm × unbegrenzter Länge machen die Arbeit komfortabler und weniger eingeschränkt.',
                  image: require('@/assets/product/laser/640-3.png'),
                },
              ],
              960: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Hervorragende Schneid- und Gravurergebnisse',
                  bgColor: '#4285F4',
                  description:
                    'Der Laserschneider ist mit einer großzügigen Arbeitsplattform ausgestattet und erreicht bei Holz- und Acrylbearbeitung unternehmensgerechte Präzision und Effizienz. Ideal für die Serienproduktion hochwertiger Laserarbeiten.',
                  image: require('@/assets/product/laser/960-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Hochwertiges Laserrohr und Präzisionskomponenten',
                  bgColor: '#FFBC0C',
                  description:
                    'Vielfältige Produktlinien ermöglichen die Auswahl unterschiedlicher Lasertypen und Bearbeitungsgeschwindigkeiten zur Erfüllung verschiedenster Produktionsanforderungen.',
                  image: require('@/assets/product/laser/960-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Strenge Strahlqualitätsprüfung und Qualitätssicherung',
                  bgColor: '#34A853',
                  description:
                    'Strenge Tests, präzise Strahlführung und mehr als fünf Schneid- und Gravurtests gewährleisten stabile und gleichmäßige Laserleistung der hochwertigen CO₂-Laserrohre.',
                  image: require('@/assets/product/laser/960-3.png'),
                },
              ],
              1390: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Umfassende & fortschrittliche Sicherheitsfunktionen',
                  bgColor: '#4285F4',
                  description: `1. Not-Aus
<br>2. Alarmleuchte
<br>3. Wasserdichter Schalter
<br>4. Erdungskabel
<br>5. Integrierter Wärmesensor-Alarm
<br>6. Klappschutz
<br>7. Gehärtetes Schutzglasfenster`,
                  image: require('@/assets/product/laser/1390-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Langlebig und von herausragender Qualität',
                  bgColor: '#FFBC0C',
                  description: `1. Ideal für Einzelprojekte oder Großserien.
<br>2. Große Auswahl an Arbeitsbereichen von 600 x 400 mm bis 1600 x 1000 mm.
<br>3. Unvergleichliche Graviergeschwindigkeit.
<br>4. Von Branchenexperten entwickelt.
<br>5. Ideal für Personalisierung, Bildung und Industrie.`,
                  image: require('@/assets/product/laser/1390-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Optimierung der Produktion durch intelligente Überwachung',
                  bgColor: '#34A853',
                  description:
                    'Speziell entwickelt zum Schutz empfindlicher Komponenten (Achsen, Laserkopf, Optik, Linsen) vor Staub und Verschmutzung – gewährleistet auch bei intensivem Einsatz jahrelangen störungsfreien Betrieb.',
                  image: require('@/assets/product/laser/1390-3.png'),
                },
              ],
              1610: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Effizienter Autofokus + Rotpunkt-Positionierung',
                  bgColor: '#4285F4',
                  description:
                    'Die Autofokus-Funktion ermöglicht eine schnelle und präzise Fokussierung vor dem Schneiden und Gravieren. Mit der Rotpunkt-Positionierung wird die Arbeitsposition in Echtzeit angezeigt, was die Effizienz deutlich steigert.',
                  image: require('@/assets/product/laser/1610-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Hervorragende Schneid- und Gravurergebnisse',
                  bgColor: '#FFBC0C',
                  description:
                    'Großzügige Schneidplattform mit unternehmensgerechter Präzision für Holz und Acryl, ideal für Serienproduktion hochwertiger Laserarbeiten.',
                  image: require('@/assets/product/laser/1610-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Langlebig und von herausragender Qualität',
                  bgColor: '#34A853',
                  description: `1. Ideal für Einzelprojekte oder Großserien.
<br>2. Große Auswahl an Arbeitsbereichen.
<br>3. Unvergleichliche Graviergeschwindigkeit.
<br>4. Von Branchenexperten entwickelt.
<br>5. Ideal für Personalisierung, Bildung und Industrie.`,
                  image: require('@/assets/product/laser/1610-3.png'),
                },
              ],
            },
          },
          {
            key: 'lightblue530',
            label: 'Light Blue 530',
            images: [
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Tragbarer Blaulicht-Gravierer',
                bgColor: '#4285F4',
                description:
                  'Modernes, kompaktes Design, geeignet für Zuhause, Schulen oder Studios. Metallgehäuse mit Acrylabdeckung – perfekt für den Tisch und mit starker 20W-Leistung für effizientes Schneiden.',
                image: require('@/assets/product/laser/blue530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title:
                  'Geschlossene Verarbeitung zur Vermeidung von Verletzungen',
                bgColor: '#FFBC0C',
                description:
                  'Vollständig geschlossenes Design: Öffnet sich der Deckel während des Betriebs, stoppt das Gerät automatisch. Not-Aus-Schalter für maximale Sicherheit – ideal für Haushalt und Schule.',
                image: require('@/assets/product/laser/blue530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Multimaterial-Bearbeitung',
                bgColor: '#34A853',
                description:
                  'Unterstützt die Bearbeitung von über hundert Materialien. Erweiterbar mit Zubehör für zylindrische oder runde Objekte – ideal für kleine Unternehmen.',
                image: require('@/assets/product/laser/blue530-3.png'),
              },
            ],
          },
          {
            key: 'markm20',
            label: 'Mark M20',
            images: [
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Vielfältige Anwendungsszenarien',
                bgColor: '#4285F4',
                description:
                  'Geeignet für Schmuckgravur, personalisierte Objekte, Teilekennzeichnung u. v. m. – von Schmuck über Parfümflaschen bis hin zu kleinen Industrieschildern.',
                image: require('@/assets/product/laser/m20.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Innovative Anwendungen im Bildungsbereich',
                bgColor: '#FFBC0C',
                description:
                  'Mark M20 bringt industrielle Präzision in den Bildungsbereich und unterstützt die Ausbildung von grundlegenden Markierfähigkeiten bis hin zu komplexen Projekten.',
                image: require('@/assets/product/laser/m20-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Kompakt und modern',
                bgColor: '#34A853',
                description:
                  'Kompaktes, modernes Design mit geringem Platzbedarf, niedriger Geräuschentwicklung und großem Sichtfenster – ideal für Bildungseinrichtungen und Einzelhandel.',
                image: require('@/assets/product/laser/m20-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Markieren in wenigen Sekunden',
                bgColor: '#0F9D58',
                description:
                  'Selbst kleinste Schriftarten werden in wenigen Sekunden präzise markiert. In Kombination mit der LightMaker-Software wird die Produktivität erheblich gesteigert.',
                image: require('@/assets/product/laser/m20-4.png'),
              },
            ],
          },
          {
            key: 'accessories',
            label: 'Zubehör',
            images: [
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
            ],
            advantages: [
              {
                description: `
· Einsatzorte: Für alle Bereiche mit Rauch, Geruch, Staub sowie giftigen oder schädlichen Gasen geeignet.
<br>· Anwendungsbereiche: Elektronik, Spielzeugherstellung, Präzisionsmetall, Medizin u. a.
<br>· Designmerkmal: Variables Einzel- oder Doppelarbeitsplatz-Design.
<br>· Filtersystem: Mehrschichtiges Filtersystem.
<br>· Luftmengenregulierung: Stufenlose Anpassung entsprechend der Abgasmenge.
<br>· Reinigungsleistung: Reinigungsrate bis zu 99,97 %.
<br>· Luftabgabe: Gereinigte Luft kann direkt im Innenraum abgegeben werden。
`,
                image: require('@/assets/product/laser/accessories1.png'),
              },
              {
                description: `· Gerätetyp: Hilfsgerät für Laser-Schneid- / Graviermaschinen.
<br>· Zweck: Realisierung der Rotation von Werkstücken.
<br>· Geeignete Objekte: Zylindrische und rohrförmige Objekte.
<br>· Erweiterung: Ermöglicht die Bearbeitung von Zylindern anstatt nur von ebenen Platten.`,
                image: require('@/assets/product/laser/accessories2.png'),
              },
              {
                description: `
· Effiziente Formmaschine für präzise Umformung.
<br>· CNC-Steuerung für einfache Bedienung.
<br>· Verschiedene Formwerkzeuge verfügbar.
<br>· Schnellspannsystem zur Effizienzsteigerung.
<br>· Umfassende Sicherheitsvorrichtungen.
<br>· Geeignet für die Umformung unterschiedlicher Materialien。`,
                image: require('@/assets/product/laser/accessories3.png'),
              },
            ],
          },
        ],
      },
    },

    support: {
      afterSales: {
        banner: {
          alt: 'Banner für Tutorial-Download',
          title: 'Tutorial-Download',
          image: require('@/assets/after/banner.png'),
        },
        downloadText: 'Tutorial herunterladen',
        items: [
          {
            id: 'mk-1',
            name: 'Intelligente Farm',
            image: 'https://picsum.photos/seed/as-farm1/588/391',
            link: '#',
          },
          {
            id: 'mk-2',
            name: 'Smart Home',
            image: 'https://picsum.photos/seed/as-home1/588/391',
            link: '#',
          },
          {
            id: 'mk-3',
            name: 'Intelligenter Verkehr',
            image: 'https://picsum.photos/seed/as-traffic1/588/391',
            link: '#',
          },
          {
            id: 'mk-4',
            name: 'Smart Factory',
            image: 'https://picsum.photos/seed/as-factory1/588/391',
            link: '#',
          },
          {
            id: 'mk-5',
            name: 'Makerspace',
            image: 'https://picsum.photos/seed/as-makerspace1/588/391',
            link: '#',
          },
          {
            id: 'mk-6',
            name: 'Roboterkurse',
            image: 'https://picsum.photos/seed/as-robot1/588/391',
            link: '#',
          },
          {
            id: 'mk-7',
            name: 'KI-Tutorials',
            image: 'https://picsum.photos/seed/as-ai1/588/391',
            link: '#',
          },
          {
            id: 'mk-8',
            name: 'IoT-Tutorials',
            image: 'https://picsum.photos/seed/as-iot1/588/391',
            link: '#',
          },
        ],
      },
    },
  },
};
